import axiosClient from '../api/AxiosConfig';

export const LadingService = {
    GetLanding: async () => {
        return (await axiosClient.get('/landing')).data;
    },
    DisableLanding: async (id) => {
        return (await axiosClient.patch(`/landing/${id}/disable`)).data;
    },
    EnableLanding: async (id) => {
        return (await axiosClient.patch(`/landing/${id}/enable`)).data;
    },
    GetLandingId: async (id) => {
        return (await axiosClient.get(`/landing/${id}`)).data;
    },
    EditLanding: async (id, data) => {
        return (await axiosClient.put(`/landing/${id}`, data)).data;
    },
}